import { MoveEntry, GameChatEntry, PlayerSeat } from './game.state';

export class GameStarted {
  static readonly type = '[Game] Game Started';
  constructor(
    public gameId: string,
    public game: string,
    public players: PlayerSeat[],
    public yourSeat: number | null,
    public initialState: unknown,
    public initialTimeSecs: number,
    public incrementSecs: number,
    public mode?: string,
    public rated?: boolean,
  ) {}
}

export class ObservationStarted {
  static readonly type = '[Game] Observation Started';
  constructor(
    public gameId: string,
    public game: string,
    public players: PlayerSeat[],
    public initialState: unknown,
    public initialTimeSecs: number,
    public incrementSecs: number,
    public currentState: unknown,
    public clocksRemainingMs: number[],
    public currentSeat: number | null,
    public moves: MoveEntry[],
    public currentPly: number,
    public rated: boolean,
    public observers: { username: string; is_bot: boolean }[],
    public chat: GameChatEntry[],
    public mode?: string,
  ) {}
}

export class ObserverJoined {
  static readonly type = '[Game] Observer Joined';
  constructor(public gameId: string, public observer: { username: string; is_bot: boolean }) {}
}

export class ObserverLeft {
  static readonly type = '[Game] Observer Left';
  constructor(public gameId: string, public username: string) {}
}

export class GameStateUpdated {
  static readonly type = '[Game] State Updated';
  constructor(
    public gameId: string,
    public state: unknown,
    public clocksRemainingMs: number[],
    public currentSeat: number | null,
  ) {}
}

export class GameOver {
  static readonly type = '[Game] Game Over';
  constructor(public gameId: string, public result: string) {}
}

export class MakeMove {
  static readonly type = '[Game] Make Move';
  constructor(public gameId: string, public moveData: unknown, public basePly?: number) {}
}

export class ResignGame {
  static readonly type = '[Game] Resign';
  constructor(public gameId: string) {}
}

export class ClaimDrawGame {
  static readonly type = '[Game] Claim Draw';
  constructor(public gameId: string) {}
}

export class OfferDrawGame {
  static readonly type = '[Game] Offer Draw';
  constructor(public gameId: string) {}
}

export class AcceptDrawGame {
  static readonly type = '[Game] Accept Draw';
  constructor(public gameId: string) {}
}

export class DeclineDrawGame {
  static readonly type = '[Game] Decline Draw';
  constructor(public gameId: string) {}
}

export class DrawOfferDeclinedReceived {
  static readonly type = '[Game] Draw Offer Declined';
  constructor(public gameId: string) {}
}

export class InvalidMoveReceived {
  static readonly type = '[Game] Invalid Move';
  constructor(public gameId: string, public reason: string) {}
}

export class LeaveGame {
  static readonly type = '[Game] Leave Game';
}

export class EndDemonstrationGame {
  static readonly type = '[Game] End Demonstration';
  constructor(public gameId: string, public save: boolean, public title?: string, public description?: string) {}
}

export class MovesHistoryReceived {
  static readonly type = '[Game] Moves History Received';
  constructor(public gameId: string, public moves: MoveEntry[]) {}
}

export class SelectMovePly {
  static readonly type = '[Game] Select Move Ply';
  constructor(public gameId: string, public ply: number) {}
}

export class GameChatReceived {
  static readonly type = '[Game] Chat Received';
  constructor(
    public gameId: string,
    public messageId: string,
    public username: string,
    public message: string,
    public timestamp: string,
    public isObserver: boolean,
  ) {}
}
